import axiosInstance from "services/AxiosInstance";
import { ResponseType, TQuestionnaireItem } from "types";

export const getQuestionnaireItemsService = async (requestId: string): Promise<ResponseType<TQuestionnaireItem[]>> => {
  const response = await axiosInstance.get(`/questionnaire/request/${requestId}/items`);
  return response.data;
};
